import * as React from "react";
import { forwardRef } from "react";
const SvgChevronSmDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2.104 6.171a1.16 1.16 0 0 1 .35-.828 1.2 1.2 0 0 1 1.68 0l3.918 3.858 3.92-3.858a1.2 1.2 0 0 1 1.68 0 1.157 1.157 0 0 1 0 1.656l-4.762 4.68a1.2 1.2 0 0 1-1.68 0l-4.762-4.68a1.16 1.16 0 0 1-.344-.828" }));
const ForwardRef = forwardRef(SvgChevronSmDown);
export { ForwardRef as ReactComponent };
